module.exports = __webpack_public_path__ + "img/openbrowser.73053145.jpeg";